<template>
  <div class="rt-table-dropdown">
    <div v-if="hasIcon" class="rt-table-dropdown-icon">
      <rt-icon :name="icon" :size="24" />
    </div>
    <el-dropdown trigger="click" @command="handleCommand">
      <div class="rt-table-dropdown-content" @click="dropdownClick">
        <p class="rt-table-dropdown-title">{{ menuList[selected].name }}</p>
        <rt-icon :name="showMore ? 'rt-base-angle_up' : 'rt-base-angle_down'" />
      </div>

      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="(item, index) in menuList"
          :icon="item.icon"
          :key="index"
          :command="index"
          >{{ item.name }}</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: 'RtTableDropdown',
  props: {
    icon: {
      type: String,
      default: ''
    },
    menuList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      showMore: false,
      selected: this.value
    };
  },
  computed: {
    hasIcon() {
      return !!this.icon;
    }
  },
  watch: {
    value(newValue) {
      this.selected = newValue;
    }
  },
  methods: {
    dropdownClick() {
      this.showMore = !this.showMore;
    },
    handleCommand(val) {
      this.showMore = false;
      this.$emit('input', val);
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtTableDropdown.vue?631f9b55